import { Survey } from '@goldcast/api/backend';

import { State } from './types';

const mutations = {
  setSurveys(state: State, surveys: Survey[]) {
    state.surveys = surveys;
  },
  addSurvey(state: State, survey: Survey) {
    state.surveys = [...state.surveys, survey];
  },
  setIsSurveysLoading(state: State, isSurveysLoading: Boolean) {
    state.isSurveysLoading = isSurveysLoading;
  },
  updateSurvey(state: State, updatedSurvey: Survey) {
    state.surveys = state.surveys.map(survey => {
      if (survey.id === updatedSurvey.id) {
        survey = {
          ...survey,
          ...updatedSurvey
        };
      }

      return survey;
    });
  },
  setIsDeleteSurveyLoading(state: State, isDeleteSurveyLoading: Boolean) {
    state.isDeleteSurveyLoading = isDeleteSurveyLoading;
  },
  deleteSurveyById(state: State, surveyId: string) {
    state.surveys = state.surveys.filter(survey => survey.id !== surveyId);
  }
};

export default mutations;
